import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'dc-maintenance-page',
  templateUrl: './maintenance-page.component.html',
  standalone: true,
  imports: [TranslateModule],
})
export class MaintenancePageComponent {}
